"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFilter = addFilter;
exports.default = void 0;
exports.matchesFilter = matchesFilter;
exports.removeFilter = removeFilter;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _state = require("./state");
var _mttPostal = _interopRequireDefault(require("@gaming/mtt-postal"));
var _lodashReplacement = _interopRequireDefault(require("./lodashReplacement"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var without = _lodashReplacement.default.without;
var filters = {
  in: {},
  // jscs:ignore disallowQuotedKeysInObjects
  out: {}
};
var _default = filters;
exports.default = _default;
function addFilter(_filters) {
  _filters = Array.isArray(_filters) ? _filters : [_filters];
  _filters.forEach(function (filter) {
    filter.direction = filter.direction || _state.state._config.filterDirection;
    (filter.direction === "both" ? ["in", "out"] : [filter.direction]).forEach(function (dir) {
      if (!filters[dir][filter.channel]) {
        filters[dir][filter.channel] = [filter.topic];
      } else if (!filters[dir][filter.channel].includes(filter.topic)) {
        filters[dir][filter.channel].push(filter.topic);
      }
    });
  });
}
function removeFilter(_filters) {
  _filters = Array.isArray(_filters) ? _filters : [_filters];
  _filters.forEach(function (filter) {
    filter.direction = filter.direction || _state.state._config.filterDirection;
    (filter.direction === "both" ? ["in", "out"] : [filter.direction]).forEach(function (dir) {
      if (filters[dir][filter.channel] && (filters[dir][filter.channel] || []).includes(filter.topic)) {
        filters[dir][filter.channel] = without(filters[dir][filter.channel], filter.topic);
      }
    });
  });
}
function matchesFilter(channel, topic, direction) {
  var channelPresent = Object.prototype.hasOwnProperty.call(filters[direction], channel);
  var topicMatch = channelPresent && (filters[direction][channel] || []).some(function (binding) {
    return _mttPostal.default.configuration.resolver.compare(binding, topic);
  });
  var blacklisting = _state.state._config.filterMode === "blacklist";
  return _state.state._config.enabled && (blacklisting && (!channelPresent || channelPresent && !topicMatch) || !blacklisting && channelPresent && topicMatch);
}